import { TW_AppBlogArticle, TW_AppBlogParagraphMargin } from "@utils/twClasses";

export default function Introduction() { 
    return (
        <div className={TW_AppBlogArticle}>
            <h1 className="mb-6 text-3xl font-semibold text-black">Welcome to Compozz!</h1>
            <p className={TW_AppBlogParagraphMargin}>
                Compozz is a data management tool that allows you to create data models, dashboards and reports.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Follow this guide to create your first workspace and discover all the features of your new tool.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                If you have any questions, please contact us at contact@compozz.com.
            </p>
        </div>
    )
}